<template>
  <div class="p-2 bg-gray-200 rounded-md self-start">
    <div class="flex flex-col">
      <div class="flex justify-center px-2"
        v-if="isLoading">
        <!-- <span class="uppercase text-gray-500">
          Status:
        </span> -->
        <span class="rounded-full py-1 px-3 font-italic"
          :style="{
            background: 'rgb(243 244 246)',
            color: 'white',
          }">
          loading
        </span>
      </div>
      <div class="flex justify-center px-2"
        v-else>
        <!-- <span class="uppercase text-gray-500">
          Status:
        </span> -->
        <span class="rounded-full py-1 px-3 uppercase font-bold"
          :style="{
            background: statusBackgroundColor(status),
            color: statusFontColor(status)
          }">
          {{ displayStatus }}
        </span>
      </div>
      <div class="flex justify-end">
        <div class="flex flex-col">
          <div>
            <div class="flex-row px-2 pt-2"
              v-if="showReceivedMessage">
              <span class="text-xs text-gray-500">
                someone will review this shortly
              </span>
            </div>
            <div class="flex-row px-2 pt-2"
              v-if="showRoutedBy">
              <span class="text-xs text-gray-500">
                Routed By:
              </span>
              <span class="text-xs text-gray-500">
                {{ displayRouterName }}
              </span>
            </div>
            <div class="flex-row px-2 pt-2"
              v-if="showRoutingBy">
              <span class="text-xs text-gray-500">
                Routing By:
              </span>
              <span class="text-xs text-gray-500">
                {{ displayRouterName }}
              </span>
            </div>
            <div class="flex-row px-2 pt-2"
              v-if="showWaitingAdditionalExtra">
              <span class="text-xs text-gray-500">
                Please check {{ requesterName }}'s email inbox for additional info required
              </span>
            </div>
          </div>
          <div class="flex-row px-2 pt-2"
            v-if="showRoutedTimestamp">
            <span class="text-xs text-gray-500">
              Changed:
            </span>
            <span class="text-xs text-gray-500">
              {{ displayCreatedAt }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    status: {
      default: undefined,
      type: String,
    },
    routerName: {
      default: undefined,
      type: String,
    },
    requesterName: {
      default: '---',
      type: String,
    },
    createdAt: undefined,
  },
  data() {
    return {
      displayStatus: '',
      options: [
        {
          value: 'received',
          label: 'Received',
          statusColor: 'rgb(243 244 246)', //white
        },
        {
          value: 'routing',
          label: 'Processing',
          statusColor: 'rgb(255 176 146)', //peach
        },
        {
          value: 'waiting_additional_info',
          label: 'Waiting on Additional Info',
          statusColor: 'rgb(245 135 53)', // orange
        },
        {
          value: 'routed',
          label: 'Processed',
          statusColor: 'rgb(0 120 212)', //blue
        },
        {
          value: 'unknown',
          label: 'Not Tracked',
          statusColor: 'rgb(200 200 200)',
        },
      ],
    }
  },
  methods: {
    statusBackgroundColor(status) {
      switch (status) {
        case 'routing':
          return 'rgb(255 176 146)'
        case 'waiting_additional_info':
          return 'rgb(245 135 53)'
        case 'routed':
          return 'rgb(0 120 212)'
        case 'unknown':
          return 'rgb(200 200 200)'
        case 'received':
        default:
          return 'rgb(243 244 246)'
      }
    },
    statusFontColor(status) {
      switch (status) {
        case 'routing':
        case 'waiting_additional_info':
        case 'routed':
          return 'white'
        case 'unknown':
          return 'gray'
        case 'received':
        default:
          return 'black'
      }
    },
  },
  computed: {
    displayRouterName() {
      if (this.routerName) {
        return this.routerName
      }
      else {
        return '---'
      }
    },
    displayCreatedAt() {
      if (this.createdAt === undefined) {
        return undefined
      }
      var date = new Date(this.createdAt).toLocaleString(
        'en-US',
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }
      )
      var time = new Date(this.createdAt).toLocaleTimeString('en-US')
      return `${time}, ${date}`
    },
    isLoading() {
      return this.status == undefined
    },
    showReceivedMessage() {
      return this.status === 'received__'
    },
    showRoutedBy() {
      return this.status === 'routed'
    },
    showRoutingBy() {
      return this.status === 'routing'
    },
    showWaitingAdditionalExtra() {
      return this.status === 'waiting_additional_info'
    },
    showRoutedTimestamp() {
      return this.createdAt !== undefined && this.status !== 'received'
    },
  },
  watch: {
    status(newValue) {
      let optionObj = this.options.find(elem => elem.value === newValue)
      this.displayStatus = optionObj?.label
    }
  },
  async mounted() {
    let optionObj = this.options.find(elem => elem.value === this.status)
    this.displayStatus = optionObj?.label
  },
  // beforeDestroy() {
  // },
  // created() {
  // }
}
</script>
